
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
const service = namespace("service");
const store = namespace("store");
@Component({})
export default class DelegatePrint extends Vue {
  @service.Action getPrintStoreLogo;
  @store.State storeData;
  @Prop({ default: () => {} })
  orderData: any;
  dayjs = dayjs;
  printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  t = t;
  get $orderData() {
    return this.orderData;
  }
  created() {
    this.getLogoImg();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo;
    });
  }
}
